import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
  Row,
  Col
} from "reactstrap";
import { addAdditionalCharges } from "store/actions/settingAction";

const AddAdditionalChargesModal = ({ addModal, addToggle, onAdd }) => {
  const { user } = useSelector((state) => state.auth);
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [fee, setFee] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const resetForm = () => {
    setName("");
    setType("");
    setFee("");
    setIsActive(false);
  };

  const handleCancelToggle = () => {
    resetForm();
    addToggle();
  };

  const handleFeeChange = (e) => {
    const inputValue = e.target.value.replace(/[^0-9]/g, "");
    setFee(inputValue);
  };

  const handleAdd = () => {
    if (!name || !fee || !type) return;

    const payload = {
      name,
      type,
      fee: Number(fee),
      isActive
    };

    if (user?.id) {
      setLoading(true);
      dispatch(
        addAdditionalCharges(user.id, payload, () => {
          setLoading(false);
          addToggle();
          resetForm();
          if (onAdd) onAdd();
        })
      );
    }
  };

  return (
    <Modal isOpen={addModal} toggle={handleCancelToggle}>
      <ModalHeader toggle={handleCancelToggle}>
        Add Additional Charge
      </ModalHeader>
      <ModalBody className="pt-0">
        <Form>
          <FormGroup>
            <Label for="chargeName">Name</Label>
            <Input
              type="text"
              id="chargeName"
              placeholder="e.g, service charges"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </FormGroup>

          <FormGroup>
            <Label for="chargeType">Type</Label>
            <Input
              type="select"
              id="chargeType"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="" disabled hidden>
                Select type
              </option>
              <option value="percentage">Percentage</option>
              <option value="fixed">Fixed</option>
            </Input>
          </FormGroup>

          <FormGroup>
            <Label for="chargeFee">Fee</Label>
            <Input
              type="text"
              id="chargeFee"
              placeholder="Enter amount"
              value={fee}
              onChange={handleFeeChange}
            />
          </FormGroup>

          <Row>
            <Col>
              <div className="form-check w-100 p-0 d-flex align-items-center justify-content-start">
                <Input
                  type="checkbox"
                  className="form-check-input timing-modal-checkbox m-0"
                  id="applyAllCheckbox"
                  value={isActive}
                  onChange={() => setIsActive(!isActive)}
                />
                <label
                  className="form-check-label timing-modal-checkbox-label ml-2"
                  htmlFor="applyAllCheckbox"
                >
                  Do you want to activate these charges?
                </label>
              </div>
            </Col>
          </Row>

          <div className="d-flex justify-content-end mt-3">
            <Button
              color="primary"
              type="button"
              onClick={handleAdd}
              disabled={!name || !fee || !type || loading}
            >
              {loading ? <Spinner color="secondary" size="sm" /> : "Add"}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default AddAdditionalChargesModal;
